import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/512c25b6/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Filtering allows a user to add or remove data items from a displayed data set by turning on and off certain predefined attributes.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Overview</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Selection methods</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Filter states</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Resetting filters</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Related</AnchorLink>
      <AnchorLink mdxType="AnchorLink">References</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
    </AnchorLinks>
    <h2>{`Overview`}</h2>
    <p>{`Filtering allows users to trim down visible items when working through large data sets. Filters can help a user find something they’re looking for, see available options within a certain set of criteria, and make a decision when faced with a large number of options.`}</p>
    <h2>{`Selection methods`}</h2>
    <p>{`Choosing the right filter selection method will improve usability and user effiency. Carbon supports several selection methods that are approrpriate for different situations. Consider the data your users are looking at, what they are trying to achieve, and how they might intuitively narrow down the data.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Selection method`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Single selection`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The user can pick only one attribute to modify data results.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Multi-selection`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The user has the option to pick more than one attribute to modify data results.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Multiple categories`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The user has the option to select attributes across multiple data categories.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Multiple filters with batch updates`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The user selects multiple filters and then takes an additional action to apply the filters.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Multiple filters with instant updates`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The data is updated as the user selects each filter.`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Single selection`}</h3>
    <p>{`Use a single-selection filter when the user can pick only one attribute to modify data results. Under the hood, single selection behaves like a `}<a parentName="p" {...{
        "href": "/components/radio-button/usage"
      }}>{`radio button`}</a>{`. Types of single-selection filters include:`}</p>
    <ul>
      <li parentName="ul">{`Basic dropdown`}</li>
      <li parentName="ul">{`Inline dropdown`}</li>
      <li parentName="ul">{`Radio button set (either standalone or within a menu)`}</li>
    </ul>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.18478260869565%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAACJUlEQVQoz5VSOYhaURT9i2ZGHVf4KOkkEEFIijQ26cYNnAyjgyjBwhgIaWwsAlo5KGqhjZWglSBYWFpYWCi4FBaCouICbqAi7tMkxsTc9wcz02QgFy7nP+5595537scwCLPZjJ3icDhgx+MRP+Vms8Fnsxn2XIjF4seDTqejUa1W4zabjfjXJZVKhYtEIpoPXEwqleIymQxTKBRIAOZwOB6IVquVRmjG1Gq1F9VqlZPJZN6m0+l3o9Ho9f39/av9fn8OFLZEImGfBgiFQgGfz794OrTb7WIYj8ejD0ajkQvAgOepJ5PJ7/l8/mO5XH5fLBYo3yMOKPn7gkgkQobDYRJZ0m63iV6v91DQaDQ0+nw+AUVRQihcj8fj42Aw+DmdTg/D4fBXLpe7lcvlArfb/dLpdFIul4tKJpMsGMBoNptMuMMEdTjdKBQK0djv9xkIQdkHWMzxaTQajRsovfB4PNx4PE74/X6yWCwiZXin08FRM/q5KAwGA42xWIxtMpm49XpdDsRvtVrtDtDbarW82Wz2jcViOQ8Gg0JoKvB6vYJoNMrZ7XYMqCN1jwpBEYG8SaVSTPCEw2KxTj4hxWgZZ3q9ngJLeIFAgA1NOaCQk0gkzuAeCZaQ0INcrVYE+Ek893uhIq5UKknsf2K9XqtB+g0s4Aq8MsG0W5h0WalUPhcKBXs+n/9UKpXs8P0V0loul+2wpC9gyUfYvmG73V4C/wryGlL5B6YvMUp3VhkqAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a single selection filter in an inline dropdown",
            "title": "Example of a single selection filter in an inline dropdown",
            "src": "/static/8b7c51ed71c96be4c5822a5a0c6001f6/3cbba/filter-1.png",
            "srcSet": ["/static/8b7c51ed71c96be4c5822a5a0c6001f6/7fc1e/filter-1.png 288w", "/static/8b7c51ed71c96be4c5822a5a0c6001f6/a5df1/filter-1.png 576w", "/static/8b7c51ed71c96be4c5822a5a0c6001f6/3cbba/filter-1.png 1152w", "/static/8b7c51ed71c96be4c5822a5a0c6001f6/392b1/filter-1.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a single selection filter in an inline dropdown</Caption>
      </Column>
    </Row>
    <h3>{`Multi-selection`}</h3>
    <p>{`Use a multi-selection filter when the user has the option to pick more than one attribute to modify the data results. Under the hood, multi-selections behave like `}<a parentName="p" {...{
        "href": "components/checkbox/usage"
      }}>{`checkboxes`}</a>{`. Types of multi-selection filters include:`}</p>
    <ul>
      <li parentName="ul">{`Multi-select dropdown`}</li>
      <li parentName="ul">{`Inline multi-select dropdown`}</li>
      <li parentName="ul">{`Checkbox set (either standalone or within a menu)`}</li>
    </ul>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.18478260869565%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAB5UlEQVQoz61RO4gaURR9M+7oOCabxSKCy5Z+SkXQymJhd5Ow634KS4stBSutTJdeTBUUDcrayoq1CH4KsfcDfkEE/6IWwsoiL+dNfiSEQCAXDue8Offde98dotPpCAvGv8NkMpFcLif76/WaUEpJLBbjEokEF41GuXw+z2UyGfI99Ho9IWq1Wj5YrVZiMBiI2WwmDoeDeDweYjQaZbBCf4tsNkv+OdDw1GazvQ+FQq+DwaDe5/OdxONxbSAQ0MCWtFotJycKgiCzxWI5xBOPGex2+6Hb7VYy7XK5XjE/nU5/rlartFarjZvN5hyYtFqtp3q9/oH5jUaD/+Ul6PoCXV/6/X4NOqvC4bDG6/UeoZC8k1KplBoMBhQXn9vtNoV+xl5pr9f7yPzZbManUqmvxVhlXFCCDwAFA/ai6nQ6ArSS5YzH40dout1uGdH9fi/zarWKMH+32yk2m83PCZPJpLJYLAp4ygE6KyKRiIhJxeVyKe+k2+3eY5qH6XT6aT6fRwHGD2jkZj6Kcf1+n5DFYsGjG1+pVNTYiTgcDkWMryoUClK5XJYmk4kKF0Wn06n408+SJIkbjUYiq4NBePLfA1UvgDuM/Bb8jmns5RznK+AG+gzfbqEvgYtv/hvoH7lgF3ANnH0BUgg0OLFeZwEAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a milti-selection filter in a checkbox set",
            "title": "Example of a milti-selection filter in a checkbox set",
            "src": "/static/a72e356edbde647f293818777f110a13/3cbba/filter-2.png",
            "srcSet": ["/static/a72e356edbde647f293818777f110a13/7fc1e/filter-2.png 288w", "/static/a72e356edbde647f293818777f110a13/a5df1/filter-2.png 576w", "/static/a72e356edbde647f293818777f110a13/3cbba/filter-2.png 1152w", "/static/a72e356edbde647f293818777f110a13/392b1/filter-2.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a multi-selection filter in a checkbox set</Caption>
      </Column>
    </Row>
    <h3>{`Selecting multiple categories`}</h3>
    <p>{`A category is a set of filter items within the same topic. For example, “size” is a category and `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, `}<inlineCode parentName="p">{`large`}</inlineCode>{`, and `}<inlineCode parentName="p">{`extra large`}</inlineCode>{` are its filter choices. Multiple filter categories may be applied to the same data set. For example, the user can filter by size, color, and price range.`}</p>
    <p>{`Multiple category selection is usually placed vertically on the left side of the page or horizontally at the top of the data set. Multiple categories should never be put within a menu or dropdown.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "76.22282608695652%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAAC2klEQVQ4y43TX0hTURwH8N/9s3+i0/273m1azk1LZ+UeLCod2YsPYSJIgqJWG6tlUBCImEFGGWQaVNBDBRVRhNabA59aLxJOIQMfFDVdKWZs00kvEt6+d2wixcADH37nHM75nXPPOZeoUyLySxx3ZpqjixLHtP3mySMpaAj9O4ogCLSrom7+xikavmbzzT8ylPWfsxSN01rySdlC3TvGKRBT4HAyVquVl8eOjo5SKBSi2dnZtOTCGnM0dqMuq8ig5a2GDDKZtKzNoNfZDQaDTa/X5xiNRgfttsS+f2EfddTw7Y0Vyp7efr6zZ0BR19Ci8Xi8qhvd3apAIKAeGRlRzMzM8CsrK/zy8nJCOBzmFhYW/kN3PsQ0Fbcl0/E+yRia/6OMroYV8kKSJKmGh4eZdBsZHBxkJicnufHxcW5iYmIblVS1cpWtj9WkfMJiXCKBzWbz4xKOIOm+tbW1wMbGRhvchAHog/vgh3PggfMplJ9nzrCIJrtVyNbaCvYmDt/lclkRVJubm6eQVIrH47fAB13QkVQGZsjfiXJFc5YoWlyCaBFzRZHHfEp+Moszy8SqNgwsRryHKO+wP+k52i/hBerbqKo8jz1kJo1ZS1qzKGSmzmhqakqdqmOSDp5iwjNIRTfICzmhNIXIKzF4yGq6LCUu4+dbt7w7CgaDHJLkYtBpRHlwJZyEahn63FD1LypsHGJtTQFdact7XW3jhUTSaCzOJnfWkDzDh/AA3iCZ/JmvEGsQyxEPQ0UK1V97bWy7crfSRaTw+q8q5URrsQj5fD4GEwoxqBPxBGITeHfcqB/97YiXELdRRc3ZDOfR2j3V7mMqOVlobIzd2pJocXFRs+MMrfARPkEwqRfkxa4nyS+gKzVHvgwu3SPGVzPYyQEoS8aDaX+91dVf++fm5suWlpYc6+vrJbFYrBiP2R6JRMpRd6Aut4vRFqLRaB5YQEBfaqz8+J2oFyGW/gWQwjubpqIIaAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of multiple filter categories",
            "title": "Example of multiple filter categories",
            "src": "/static/b356a7de040357b2d544d028902cd0f4/3cbba/filter-3.png",
            "srcSet": ["/static/b356a7de040357b2d544d028902cd0f4/7fc1e/filter-3.png 288w", "/static/b356a7de040357b2d544d028902cd0f4/a5df1/filter-3.png 576w", "/static/b356a7de040357b2d544d028902cd0f4/3cbba/filter-3.png 1152w", "/static/b356a7de040357b2d544d028902cd0f4/392b1/filter-3.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of multiple filter categories</Caption>
      </Column>
    </Row>
    <h3>{`Multiple filters with batch updates`}</h3>
    <p>{`Use a batch filter when all filters are applied together at the end of the selection process. The data set only refreshes once at user action. The trigger is most commonly an “Apply filters” button.`}</p>
    <p>{`The batch filter works best when the user is making several filtering selections across different categories that may take a longer time to mentally process. Batch filtering is also a good solution for slow data-return speeds. This can prevent the user from having to wait for the data to load after every selection.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.57065217391304%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAB7ElEQVQoz62TT4vTQBjGO9X1tqdW1E8hlO3SjabJsrVXYb/ChpXFoiie/C49uCg9llh78eChFSt4KKW9FNpCoX9tm39tdpNOMq/vzK6gZC+CAw/vzDN5f/MkTGKxP8Zms4n9t+H7vqjL5TIGAKRUKpFisUiazSbpdDqEe0EQkFardYs/NxqN3tTr9Yc4JePxmESAq9Uqfg1M4fzHer3+hokbjuMIodcwTbOB/ndc13APBoOByns8z4tHgPP5XJiLxeLItm0wDEMIkwNjDBAGeBhQSgGTioreHu/BGgUOh0NhzmYztd1u89MpwgNME2CaoNvtBr1eT6wx5RYH4P4+78EAUeBkMvkNPJxOp9Dv9xkmZDytZVlgWo6QZTvMsteh51OY/1wKoGHeAHRdN35dD/npHIbfhoVhCAG+Hts6AFdiqBAncOlcJQw9KwrUdV2Y5XJZrVargNpWKhVa+ahT/dNn+r5m0/OvHj2vX6Au/Q8NCsUvVpr3vKu5UWAmkxFmOp1+ksvlIJ/Pw6PHMhzspyAlP4XkyxDuvQXYfQ1wuwBw5xXAjuYd8J6d0zAKzGaz4i7JsvxAUZRTVVVPFEXVVFnSpKNj7f7ZREu+8LVkwdUShYsT1LPEmXGX9ySeb8iNl1uSpH/+IXYL8Nf6F3bfdJXMfGA/AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of batch filtering",
            "title": "Example of batch filtering",
            "src": "/static/71e468ec69d1cf8bd3fb51c6a2435f4e/3cbba/filter-4.png",
            "srcSet": ["/static/71e468ec69d1cf8bd3fb51c6a2435f4e/7fc1e/filter-4.png 288w", "/static/71e468ec69d1cf8bd3fb51c6a2435f4e/a5df1/filter-4.png 576w", "/static/71e468ec69d1cf8bd3fb51c6a2435f4e/3cbba/filter-4.png 1152w", "/static/71e468ec69d1cf8bd3fb51c6a2435f4e/392b1/filter-4.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of batch filtering</Caption>
      </Column>
    </Row>
    <h3>{`Multiple filters with instant updates`}</h3>
    <p>{`This method returns results after each individual selection is made. The trigger is the individual selection and the filter manipulates the data in real time. This is a good solution for when the user is only selecting from one category or the user is expected to only make one filter selection.`}</p>
    <h2>{`Filter states`}</h2>
    <p>{`Filters within each category should start either as `}<em parentName="p">{`all unselected`}</em>{` or `}<em parentName="p">{`all selected`}</em>{`. When using multiple categories, the start state can vary from category to category. If the user typically wants only one or a few criteria to be excluded from the results, then all filters should be selected at the start. If the user typically wants to see only results related to one particular criteria, then all filters should start as unselected.`}</p>
    <p>{`If the filter(s) can be hidden in either a drawer, dropdown, or menu, then there should be an indicator visible on the closed filter state that informs the user that filters have been applied. At a minimum, the indicator should include the number of filters applied and have the option to clear filters without re-opening the filter container.`}</p>
    <Row mdxType="Row">
      <Column colLg={6} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.91847826086957%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABlklEQVQoz52TzWrCQBDHd4vxA7xYe2gfpWBPgtc+hUfx6tGLeNM3iAcvAY9BH0ChTyDiV4xGE038Dgq9SDqzZGNDxGIHNjuT2f3lPztZQlzL5XLkvzYej6/BaDQi2WyWQ6P5fD7uOA4dDAZPkPMN2OjNp9OJuj7lHAbGR71eZ0BZloVmsxmbTCYCLAjjgLw3eDwcDsPtdjvivgtxlQj1rNPpPFRmIpEIc19RFH/9hUKB+aVSKQ5q41CO0O/3I79UoY/KY7PZLKZpWlSSJDwWzAmc45VcrVYZUBRF2mq16HK5pFAWnhFVVZXWarVbjXiFdQxmWdYVyK1cLgc2QXPYfDgcQgB+13U9Deo/IP4E2Nd6vX5zgdTX5WKxyPxKpUIajQbZ7XYEyvEWbjab58ViYZzPZ+d4PDqXywVnbTqdJjFvmiYNKLxlHLjdbhGoQOyAsm/bthGownkmAwrvGX7ZBSbn87mJCnGg7fd7C4AvmF+tVvShGwAbQ71eLwXHkDEMIw3wDHQ61e12hcBN+cvg63fz8Cv54h/EhVSjENJQ+QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of hidden filters not applied",
            "title": "Example of hidden filters not applied",
            "src": "/static/a5a2dd510ea2b011203576e8ba8a82f5/3cbba/filter-5.png",
            "srcSet": ["/static/a5a2dd510ea2b011203576e8ba8a82f5/7fc1e/filter-5.png 288w", "/static/a5a2dd510ea2b011203576e8ba8a82f5/a5df1/filter-5.png 576w", "/static/a5a2dd510ea2b011203576e8ba8a82f5/3cbba/filter-5.png 1152w", "/static/a5a2dd510ea2b011203576e8ba8a82f5/392b1/filter-5.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of filter without selections</Caption>
      </Column>
      <Column colLg={6} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.91847826086957%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABuUlEQVQoz51Tu2oCQRTdMbsag1UMaArrfIR2AXs/YkuxCWKhYCN2+gcWWlqKtoLbWVgJvo0PXN0VnygEESZnBnfFGMzjwN2dO/fOuefeYQThhGAwKPwX3W737HQ6HUGWZYP0PhQKOSilpNVqWRAzbTgcWiqVigUxnjufz/l+r9cjBg8nZp9cLseTCoWCVCwW7f1+X0KClRni3Or1uhVkYiwWcwQCAVe1WuX7KCwaKhmpCUVRftWe2+1+8Xg8b1jeGXtQedl/JBLh60Qi4YBax263k5rNpo0pOKm0NRoNO1Q+QKWNjaRcLhPkWEEmGTxmy+l0mhNmMhlSKpXIdDol7XabgIxgdiQajX4V6kLMhTxOpuv6mdBAMpm8as+4gMPhIGIkXvjebDYrh8PhMkiU2Wz2fCIkF7ccj8f5OpVKCfl8XlgulwKGbSbu9/vHWq2mYhR0vV7T4/FIN5vNaDAYOFlc0zRypfA7GITb7fYRBXo4SNHmB3xG+I5xOK8U3gKrzP6LxcI5mUw0KKXMGFarlQ7CJxZH6+RPLwAHRdywDyr9qqq+jsdj/2g08mFPunopPwHVb8bxCC78T3UWT1mxts6sAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of hidden filters applied",
            "title": "Example of hidden filters applied",
            "src": "/static/398a3e7dc4339ae3b0058c24dd73f297/3cbba/filter-6.png",
            "srcSet": ["/static/398a3e7dc4339ae3b0058c24dd73f297/7fc1e/filter-6.png 288w", "/static/398a3e7dc4339ae3b0058c24dd73f297/a5df1/filter-6.png 576w", "/static/398a3e7dc4339ae3b0058c24dd73f297/3cbba/filter-6.png 1152w", "/static/398a3e7dc4339ae3b0058c24dd73f297/392b1/filter-6.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of filter with selections</Caption>
      </Column>
    </Row>
    <h2>{`Resetting filters`}</h2>
    <p>{`Each category should have a way to clear all applied filters at once without having to interact with each individual item. Clearing filters returns the filters to their original default starting state.`}</p>
    <p>{`If multiple categories have been applied to the same data set then there should also be a way to dismiss all filters across all categories at once.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "31.38586956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAABMElEQVQY03XQv0vDQBQH8EsTpMUfTUorBSvWpDHRqpHaISD4D2TSuSpEwdFJs1oRl4JVZzdBNxdH5/wzGfKTDGY5v3cEJ3vw4b0Ld+/yHiFsnVEeyIgKxKV1ckmXRPenQspFKRU9zxPIjJVlmQgSwz8cX3/yePHwLRy6r4u1g0mV7U1jQ1FV1UNaQ9H9NE2/4ARu4B7GcIdC5zCCU15ouanw2Go25tst2VhpSAvyHKlYewPJsqxu+RdHKEpZIeRXwOItjGEXOtAlSZIIvu/z9mzbrmuaNjQMs+04ThX3/1oOgkDBhVUUNGECTzAtvcEHvP83EjYH1rI4Y14yPMIzTOEFhrAGOonjWAcTNqMo6uGVraIo9DzPdez76KAXhmEfLOTs7DZYsAMDFnFuHVTknV88rOKp85JtBAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Filter reset example",
            "title": "Filter reset example",
            "src": "/static/6463d6bde4072d3236ef35304a23f885/3cbba/filter-7.png",
            "srcSet": ["/static/6463d6bde4072d3236ef35304a23f885/7fc1e/filter-7.png 288w", "/static/6463d6bde4072d3236ef35304a23f885/a5df1/filter-7.png 576w", "/static/6463d6bde4072d3236ef35304a23f885/3cbba/filter-7.png 1152w", "/static/6463d6bde4072d3236ef35304a23f885/392b1/filter-7.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption"></Caption>
      </Column>
    </Row>
    <h2>{`Related`}</h2>
    <Row mdxType="Row">
      <Column colSm={2} colMd={2} colLg={4} mdxType="Column">
        <h4>{`Components`}</h4>
        <ul>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/radio-button/usage"
            }}>{`Radio button`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/dropdown/usage"
            }}>{`Dropdown`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/checkbox/usage"
            }}>{`Checkbox`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/data-table/usage"
            }}>{`Data table`}</a></li>
        </ul>
      </Column>
      <Column colSm={2} colMd={2} colLg={4} mdxType="Column">
        <h4>{`Patterns`}</h4>
        <ul>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/patterns/common-actions#clear"
            }}>{`Clear`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/patterns/notification-pattern"
            }}>{`Notifications`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "patterns/search-pattern"
            }}>{`Search`}</a></li>
        </ul>
      </Column>
    </Row>
    <h2>{`References`}</h2>
    <ul>
      <li parentName="ul">{`Patternfly, `}<a parentName="li" {...{
          "href": "https://www.patternfly.org/v4/design-guidelines/usage-and-behavior/filters"
        }}>{`Filters`}</a>{` (2019)`}</li>
      <li parentName="ul">{`Nick Babich, `}<a parentName="li" {...{
          "href": "https://uxplanet.org/best-practices-for-search-results-1bbed9d7a311"
        }}>{`Best Practices for Search Results`}</a>{` (2017)`}</li>
      <li parentName="ul">{`Think with Google, `}<a parentName="li" {...{
          "href": "https://www.thinkwithgoogle.com/marketing-resources/experience-design/chapter-2-in-app-search/"
        }}>{`In-App Search`}</a>{` (2016)`}</li>
    </ul>
    <h2>{`Feedback`}</h2>
    <p>{`Help us improve this pattern by providing feedback, asking questions, and leaving any other comments `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-website/issues/new?assignees=&labels=feedback&template=feedback.md"
      }}>{`on GitHub`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      